
export function LoadingIcon() {
  return (
    <div className="loading-icon">
      <div className="loading-icon__circle-transparent loading-icon__circle-circle"></div>
      <div className="loading-icon__circle-color-box">
        <div className="loading-icon__circle-color-box--circle loading-icon__circle-circle"></div>
      </div>
    </div>
  )
}
